<div class="main-section">
  <div class="main-section-content">
    <ng-template #sendToRepModal let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h6 class="modal-title">
          <i class="nav-icon fas fa-envelope-open-text"></i> Order Inquiry
        </h6>
        <button
          type="button"
          class="btn btn-close"
          aria-label="Close"
          (click)="closeEditModal(true)"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="modal-body email-scrollbar">
        <div class="mainPopupModual">
          <div class="col-xl-12 col-lg-12 spacing">
            <form [formGroup]="sendEmailForm">
              <div class="form-group">
                <div class="d-flex">
                  <div class="col-4">
                    <label for="CustomerName" name="title" class="form-label"
                      ><b>Customer Name</b></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="customerName"
                      formControlName="customerName"
                      name="customerName"
                      placeholder="Customer Name"
                      [appSetReadOnly]="
                        sendEmailForm?.get('customerName')?.value ? true : false
                      "
                    />
                  </div>

                  <div class="col-4">
                    <label for="CreatedDate" name="title" class="form-label"
                      ><b>Date</b></label
                    >
                    <input
                      type="date"
                      class="form-control"
                      id="createdDate"
                      formControlName="createdDate"
                      name="createdDate"
                      placeholder="Created Date"
                      [appSetReadOnly]="
                        sendEmailForm?.get('createdDate')?.value ? true : false
                      "
                    />
                  </div>

                  <div class="col-4">
                    <label for="CustomerName" name="title" class="form-label"
                      ><b>Order total</b></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="totalAmount"
                      formControlName="totalAmount"
                      name="totalAmount"
                      placeholder="Order Total"
                      [appSetReadOnly]="
                        sendEmailForm?.get('totalAmount')?.value ? true : false
                      "
                    />
                  </div>
                </div>
                <div class="col-12 mt-2">
                  <label for="Subject" name="title" class="form-label"
                    ><b>Subject</b></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="subject"
                    formControlName="subject"
                    name="subject"
                    placeholder="Subject"
                  />
                </div>
                <div class="col-12 mt-2">
                  <label for="Description" name="title" class="form-label"
                    ><b>Description</b></label
                  >
                  <br />
                  <textarea
                    class="form-control"
                    name="description"
                    id="description"
                    formControlName="description"
                    placeholder="Description"
                    rows="4"
                    cols="98"
                  ></textarea>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="btn-save d-flex justify-content-between col-12">
          <button class="btn btn-danger" (click)="closeEditModal(true)">
            Cancel
          </button>
          <button class="btn blue-btn" (click)="sendEmail()">
            Send To Rep
          </button>
        </div>
      </div>
    </ng-template>

    <ng-template #sendCopyOfOrder let-c="close" let-d="dismiss">
      <div class="modal-header">
        <h6 class="modal-title">
          <i class="fas fa-mail-bulk"></i> Send Copy of Order
        </h6>
        <button
          type="button"
          class="btn btn-close"
          aria-label="Close"
          (click)="closeEditModal(true)"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="modal-body email-scrollbar">
        <div class="mainPopupModual">
          <div class="col-xl-12 col-lg-12 spacing">
            <form [formGroup]="sendCopyOfOrderForm">
              <div class="form-group">
                <div class="col-12 d-flex justify-content-center">
                  <div class="col-3">
                    <label for="CustomerMailId" name="title" class="form-label"
                      ><b>Customer</b></label
                    >
                  </div>
                  <div class="col-11">
                    <input
                      type="text"
                      class="form-control"
                      id="customerMailId"
                      formControlName="customerMailId"
                      name="customerMailId"
                      placeholder="Customer Mail Id"
                    />
                  </div>
                </div>
                <div class="col-12 d-flex justify-content-center mt-2">
                  <div class="col-3">
                    <label for="SalesRepMailId" name="title" class="form-label"
                      ><b>Sales Rep</b></label
                    >
                  </div>
                  <div class="col-11">
                    <input
                      type="text"
                      class="form-control"
                      id="salesRepMailId"
                      formControlName="salesRepMailId"
                      name="salesRepMailId"
                      placeholder="Sales Rep Mail Id"
                    />
                  </div>
                </div>

                <div class="col-12 d-flex justify-content-center mt-2">
                  <div class="col-3">
                    <label
                      for="ManufacturerMailId"
                      name="title"
                      class="form-label"
                      ><b>Manufacture</b></label
                    >
                  </div>
                  <div class="col-11">
                    <input
                      type="text"
                      class="form-control"
                      id="manufacturerMailId"
                      formControlName="manufacturerMailId"
                      name="manufacturerMailId"
                      placeholder="Manufacturer Mail Id"
                    />
                  </div>
                </div>
                <div class="col-12 d-flex justify-content-center mt-2">
                  <div class="col-3">
                    <label
                      for="WrittenForMailId"
                      name="title"
                      class="form-label"
                      ><b>WrittenFor</b></label
                    >
                  </div>
                  <div class="col-11">
                    <input
                      type="text"
                      class="form-control"
                      id="writtenForMailId"
                      formControlName="writtenForMailId"
                      name="writtenForMailId"
                      placeholder="Written For Mail Id"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="btn-save d-flex justify-content-between col-12">
          <button class="btn btn-danger" (click)="closeEditModal(true)">
            Cancel
          </button>
          <button class="btn blue-btn" (click)="sendCopyOfEmail()">
            <i class="fas fa-paper-plane"></i> Send Copy Of Order
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<div class="loading-shade" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>
